<template>
  <div id="payment-type-transfer" class="payment-type-transfer" v-if="isVisible">
    <div v-if="isTransferAllowed">
      <div v-if="isTransferEnabled" class="payment-type-transfer-enable-block">
        <div class="--title">{{ getLocalization('Transfer money to another account') }}</div>
        <div class="payment-type-transfer-input-block">
          <input
              v-model="email"
              class="input"
              type="text"
              :placeholder="getLocalization('Email')"
              @input="formatEmailInput"
          >
          <input
              v-model="amount"
              class="input"
              type="text"
              :placeholder="getLocalization('Amount, rub')"
              @input="formatAmountInput"
          >
        </div>
        <button @click="checkBeforeTransfer()" class="button primary">{{ getLocalization('TRANSFER') }}</button>
      </div>

      <div v-else class="payment-type-transfer-enable-block">
        <div class="--title">{{ getLocalization('Transfer Funds to Another Account') }}</div>
        <div class="-body">
          {{ getLocalization('Balance transfers are currently disabled for your account.\nYou can enable this feature by clicking the button below.') }}
        </div>
        <button @click="enableBalanceTransfer()" class="button">{{ getLocalization('Enable balance transfers') }}</button>
      </div>
    </div>
    <div v-else>
      <div class="payment-type-transfer-enable-block">
        <div class="--title">{{ getLocalization('Transfer Funds to Another Account') }}</div>
        <div class="-body">
          {{ getLocalization('Balance transfers are currently disabled for your account.Contact support to connect it.') }}
        </div>
      </div>
    </div>

    <Modal
        :style="isVisibleConfirmModal ? 'display: flex' : 'display: none'"
        :show="isVisibleConfirmModal"
        :scrollable="true"
        modal-class="modal-transfer-money"
        @close="closeConfirmationModal"
    >
      <template #body>
        <button class="buy-number-modal-close-btn" @click="closeConfirmationModal()"></button>

        <div class="transfer-money-modal-body" ref="modalBody">
          <div class="--title" style="white-space: pre-line;">
            {{ getLocalization('DO YOU WANT TO MAKE\nA TRANSFER TO THE CLIENT') }}
             <span ref="emailContainer" class="email-container">{{ wrappedEmail }}</span>
          </div>
          <div class="--title">
            {{ getLocalization('IN THE AMOUNT OF') }} <span>{{ amount }}</span> {{ getLocalization('RUB') }}?
          </div>

          <div class="button-block">
            <button @click="transferMoney()" class="button primary">{{ getLocalization('YES') }}</button>
            <button @click="closeConfirmationModal()" class="button cancel">{{ getLocalization('NO') }}</button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import BaseAdminMixin from "../../../../admin/components/mixins/BaseAdminMixin.vue";
import Modal from "../../../../components/table/modalNew.vue";

export default {
  name: "transferPage",
  components: { Modal },
  props: ['isVisible', 'user'],
  mixins: [BaseAdminMixin],
  data() {
    return {
      isTransferEnabled: false,
      isTransferAllowed: false,
      email: null,
      amount: null,
      isVisibleConfirmModal: false,
      resizeObserver: null,
      modalWidth: 0,
      emailWidth: 0,
      textWidth: 0
    };
  },
  computed: {
    wrappedEmail() {
      if (!this.email) return '';

      // Если еще не измерили ширину или текст помещается
      if (this.modalWidth === 0 || this.textWidth <= this.emailWidth) {
        return this.email;
      }

      // Находим оптимальное место для переноса (после символа @ или перед последней точкой)
      const atIndex = this.email.lastIndexOf('@');
      const lastDotIndex = this.email.lastIndexOf('.');

      if (atIndex > 0) {
        // Переносим перед @ (оставляем @ на второй строке)
        return `${this.email.substring(0, atIndex)}\n@${this.email.substring(atIndex + 1)}`;
      }

      if (atIndex > 0 && atIndex < this.email.length - 1) {
        return `${this.email.substring(0, atIndex + 1)}\n${this.email.substring(atIndex + 1)}`;
      }

      if (lastDotIndex > 0 && lastDotIndex < this.email.length - 1) {
        return `${this.email.substring(0, lastDotIndex)}\n${this.email.substring(lastDotIndex)}`;
      }

      // Если нет @ и ., разбиваем пополам
      const middle = Math.floor(this.email.length / 2);
      return `${this.email.substring(0, middle)}\n${this.email.substring(middle)}`;
    }
  },
  watch: {
    isVisibleConfirmModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.measureTextDimensions();
        });
      }
    }
  },
  methods: {
    formatEmailInput() {
      if (this.email) {
        this.email = this.email.replace(/\s/g, '');
        if (this.email.length > 38) {
          this.email = this.email.substring(0, 38);
        }
      }
    },
    formatAmountInput() {
      if (this.amount) {
        this.amount = this.amount.replace(/\D/g, '');
        if (this.amount.length > 7) {
          this.amount = this.amount.substring(0, 7);
        }
      }
    },
    measureTextDimensions() {
      if (!this.$refs.modalBody || !this.$refs.emailContainer) return;

      this.modalWidth = this.$refs.modalBody.offsetWidth;
      this.emailWidth = this.$refs.emailContainer.offsetWidth;

      const tempSpan = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.position = 'absolute';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.fontSize = window.getComputedStyle(this.$refs.emailContainer).fontSize;
      tempSpan.style.fontFamily = window.getComputedStyle(this.$refs.emailContainer).fontFamily;
      tempSpan.textContent = this.email;
      document.body.appendChild(tempSpan);

      this.textWidth = tempSpan.offsetWidth;
      document.body.removeChild(tempSpan);
    },
    initResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver(() => {
        this.measureTextDimensions();
      });

      if (this.$refs.modalBody) {
        this.resizeObserver.observe(this.$refs.modalBody);
      }
    },
    async isTransferAllowedForUser() {
      if (this.user) {
        const response = await this.sendRequest('/cabinet/payment/isTransferAllowed', 'post');
        this.isTransferAllowed = response.isTransferAllowed;
      }
    },
    async isTransferEnabledForUser() {
      if (this.user) {
        const response = await this.sendRequest('/cabinet/payment/isTransferEnabled', 'post');
        this.isTransferEnabled = response.isTransferEnabled;
      }
    },
    checkBeforeTransfer() {
      if (!this.checkFormCompletion()) return;
      this.isVisibleConfirmModal = true;
    },
    checkFormCompletion() {
      if (!this.email || !this.amount) {
        this.alertMessage(this.getLocalization('The form is not filled out.'), 'error');
        return false;
      }
      return true;
    },
    async transferMoney() {
      const requestData = { email: this.email, amount: this.amount };
      const response = await this.sendRequest('/cabinet/payment/transferMoney', 'post', requestData);

      if (response && response.status) {
        await this.alertMessage(
            this.getLocalization('The transfer was completed successfully.'),
            'good'
        );

        await this.clearForm();
      }
      if (response && !response.status) {
        await this.alertMessage(
            this.getLocalization(response.message),
            'error'
        );
      }

      await this.closeConfirmationModal();
    },
    clearForm() {
      this.amount = null;
      this.email = null;
    },
    async enableBalanceTransfer() {
      const response = await this.sendRequest('/cabinet/payment/enableBalanceTransfer', 'post');
      this.isTransferEnabled = response.isTransferEnabled;
    },
    closeConfirmationModal() {
      this.isVisibleConfirmModal = false;
    }
  },
  mounted() {
    this.isTransferAllowedForUser();
    this.isTransferEnabledForUser();
    this.initResizeObserver();
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  updated() {
    this.initResizeObserver();
  }
};
</script>